<template>
  <div class="app_tree">
    <div style=" padding: 15px 10px;font-weight: 600;font-size: 15px">
      目录
      <el-popover
        popper-class="zl_sidebar_popper"
        placement="bottom"
        width="100"
        trigger="click"
      >
        <div class="zl_sidebar_popper_btn" style="user-select: none">
          <p class="popper_p" @click="addTreeItem">
            <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加节点">
            <span>添加节点</span>
          </p>
          <!-- 0节点，1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频 -->
        </div>

        <i
          slot="reference"
          class="el-icon-circle-plus-outline"
          style="float: right;cursor: pointer"
        ></i>
      </el-popover>

    </div>

    <el-tree
      :data="treeData"
      node-key="id"
      :style="{ height }"
      :props="defaultProps"
      :draggable="true"
      @node-drop="handleDrop"
      @node-click="handleNodeClick"
      ref="tree"
      :highlight-current="true"
      :default-expanded-keys="[defaultExpansion]"
    >
      <div
        class="custom-tree-node"
        slot-scope="{ node, data }"
        @mouseover.passive="treeMouseOver($event, data)"
        @mouseleave.passive="treemouseLeave()"
        @dblclick="edit(data)"
      >
        <span v-if="data.id && data.status != 1" :title="data.catalogName">{{data.catalogName}}</span>

        <el-input
          class="nodeInput"
          v-if="data.status == 1"
          style="width: 90%; margin-right: 20px"
          v-model="data.catalogName"
          size="small"
          placeholder="添加目录"
          :ref="'edit' + data.id"
          @blur="blurEdit(data)"
          @keyup.enter.native="enterBlur($event, data)"
          maxlength="100"
        ></el-input>

        <span v-if="iconIsShow == data.id">
          <el-popover
            popper-class="zl_sidebar_popper1"
            placement="bottom"
            width="100"
            trigger="click"
          >
            <div class="zl_sidebar_popper_btn" style="user-select: none">
              <p class="popper_p" @click="edit(data)">
                <img src="../../../static/images/newCourseImages/zh@2x.png" alt="编辑节点">
                <span>编辑节点</span>
              </p>
              <p class="popper_p" @click="remove(node, data)">
                <img src="../../../static/images/newCourseImages/sc@2x(1).png" alt="删除节点">
                <span>删除节点</span>
              </p>
            </div>

            <span
              @click.stop="openSelectType"
              slot="reference"
              v-if="data.id"
              class="el-icon-more catalogedtordel"
              :class="{'tree-node-block': iconIsShow == data.id && data.status != 1}"
            ></span>
          </el-popover>

          <el-popover
            popper-class="zl_sidebar_popper"
            placement="bottom"
            width="100"
            trigger="click"
          >
            <div class="zl_sidebar_popper_btn" style="user-select: none">

              <p class="popper_p" @click="append(node, data, 6)">
                <img src="../../../static/images/newCourseImages/zh@2x.png" alt="混合模式">
                <span>混合模式</span>
              </p>
              <p class="popper_p" @click="append(node, data, 10)">
                <img src="../../../static/images/newCourseImages/sp@2x.png" alt="添加视频">
                <span>添加视频</span>
              </p>
              <p class="popper_p" @click="append(node, data, 8)">
                <img src="../../../static/images/newCourseImages/wd@2x.png" alt="添加文本">
                <span>添加文本</span>
              </p>
              <p class="popper_p" @click="append(node, data, 5)">
                <img src="../../../static/images/newCourseImages/ceyan@2x.png" alt="添加测验">
                <span>添加测验</span>
              </p>
<!--              <p class="popper_p" @click="append(node, data, 3)">-->
<!--                <img src="../../../static/images/newCourseImages/sc@2x.png" alt="添加实操">-->
<!--               <span>添加实操</span>-->
<!--              </p>-->
              <p class="popper_p" @click="append(node, data, 7)">
                <img src="../../../static/images/newCourseImages/tp@2x.png" alt="添加图片">
                <span>添加图片</span>
              </p>
              <p class="popper_p" @click="append(node, data, 9)">
                <img src="../../../static/images/newCourseImages/yp@2x.png" alt="添加音频">
                <span>添加音频</span>
              </p>
              <p class="popper_p" v-if="data.catalogParentId === 0" @click="append(node, data, 0)">
                 <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加节点">
                 <span>添加节点</span>
              </p>
       <!-- 0节点，1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频 -->
            </div>

            <i
              slot="reference"
              class="el-icon-circle-plus-outline"
              v-if="data.resourceBase && data.resourceBase.length == 0"
              :class="{'tree-node-block': iconIsShow == data.id && data.status != 1}"
              @click.stop="openSelectType"
            ></i>
          </el-popover>
        </span>
      </div>
    </el-tree>
  </div>
</template>

<script>
import * as api from "../../api/courseApi";
/**
 *        新课程目录树，可修改新增，拖拽
 *              -- Author by wjl. on 2021.7.2
 */
export default {
  name:"zl-sidebar",
  props: {
    courseId: {
      type: [String, Number],
      default: 0,
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      treeData: [],
      defaultExpansion: 0, //默认展开的目录
      height: window.innerHeight / 1.4 + "px",
      defaultProps: {
        //目录配置
        children: "children",
        label: "catalogName",
      },
      // 2021.7.6
      popover_visible: false,
      iconIsShow: -1,
      // 2021.7.12
      oldCatalogName: "",
    };
  },
  created() {
    this.getCourseCatalog();
  },
  mounted() {


  },
  methods: {
    getCourseCatalog() {
      //获取课程目录
      api
        .getCourseAllCatalog(this.courseId)
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.treeData = res.data;
              this.$nextTick(() => {
                // 默认高亮选中节点
               let moren = sessionStorage.getItem('handleTreeNodeClick');
               if (moren){
                 let data = JSON.parse(moren)
                this.defualtOne(data)
               }else{
                 if (this.treeData[0].children && this.treeData[0].children.length){
                    if (this.treeData[0].children[0].children && this.treeData[0].children[0].children.length){
                      this.defualtOne(this.treeData[0].children[0].children[0])
                    }else{
                      this.defualtOne(this.treeData[0].children[0])
                    }
                 }
               }
              });
            }
          } else {
            this.$messageError(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    defualtOne(data){
      this.defaultExpansion = data.id;
      this.$nextTick(()=>{
        this.$refs.tree.setCurrentKey(this.defaultExpansion);
      })
      this.handleNodeClick(data);
    },
    handleNodeClick(data) {
      if (!data.catalogName) return;
      //点击课程目录
      this.$emit("handleTreeNodeClick", data);
      sessionStorage.setItem('handleTreeNodeClick', JSON.stringify(data))
    },
    // *  type 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频
    // 添加一级目录（章节）
    addTreeItem() {
      this.resertTree(this.treeData);
      var obj = {
        catalogName: "",
        catalogParentId: 0,
        id: "",
        status: 1,
        courseId: this.courseId,
      };
      this.treeData.push({ ...obj });
      this.edit({ ...obj });
    },
    // 编辑节点
    edit(data) {
      this.$set(data, "status", 1);
      if (data.catalogName) {
        this.oldCatalogName = data.catalogName;
      }
      this.$nextTick(() => {
        let that = this;
       let timer = setTimeout(() => {
          that.$refs["edit" + data.id].$refs.input.focus();
          clearTimeout(timer)
        }, 30);
      });
    },
    openSelectType() {
      this.popover_visible = true;
    },
    // 新增子目录
    append(node, data, type) {
      //  7图片，8文档, 9音频，10视频
      this.iconIsShow = -1;
      this.popover_visible = false;
      this.resertTree(this.treeData);
      this.defaultExpansion = 0;
      if (type > 0) {
        this.$emit("openAddResoures", {type}, data, 'add');
        return;
      }

      let obj = {
        id: "",
        type, // 素材分类
        catalogType: type, // 素材分类
        status: 1,
        catalogName: "",
        catalogParentId: data.id,
        courseId: this.courseId,
      };
      data.children.push({ ...obj });
      this.edit({ id: "" });
      this.defaultExpansion=data.id;
    },
    // 目录节点拖拽完成
    handleDrop(before, after, inner) {
      let level = 0;
      if (inner == "before") {
        level = 0;
      } else if (inner == "inner") {
        level = 1;
      } else if (inner == "after") {
        level = 2;
      }
      // 拖拽成功完成时触发的事件
      let obj = {
        catalogId: before.data.id,
        courseId: this.courseId,
        professionId: this.professionId,
        level: level,
        targetId: after.data.id,
        // catalogSort:0
      };
      api
        .handleDrop(obj)
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });
    },
    // 编辑tree input 失去焦点
    blurEdit(data) {
      if (data.catalogName == "" || this.oldCatalogName == data.catalogName) {
        this.$set(data, "status", 0);
        // 空的不保存不提示没反应
        this.resertTree(this.treeData);
        return;
      }
      this.defaultExpansion = 0;
      if (data.id) {
        let obj = {
          id:data.id,
          catalogName:data.catalogName
        }
        api
          .editCatalogSave(obj)
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("修改成功");
              this.defaultExpansion=data.id;
              this.getCourseCatalog();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        api
          .addCatalog(data, { method: "post" })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("添加成功");
              this.defaultExpansion=res.data.id;
              this.getCourseCatalog();
              this.$set(data, "status", 0);
              // 如果有type,是添加素材目录，并添加素材
              if (data.type == 6){
                this.addImageText(res.data, data)
              }else if (data.type){
                this.addResourse(res.data, data);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //  保存图文内容
    addImageText(catalog, data){
      console.log(data.resourceId)
      let arr = JSON.parse(data.resourceId).map((val,ind)=>{
        if(val.teptId>0){

        }else{
          val.teptId = (new Date().getTime())+val.sort
        }
        return val
      })
      let params = {
        subjectId: this.subjectId,
        name: data.catalogName,
        imageText: JSON.stringify(arr),
      };
      api.postAddImageText(params).then((res) => {
        if (res.code == 0) {
          let param = {
            courseId:data.courseId,
            type:data.type,
            resourceId:res.data.id,
          }
          this.addResourse(catalog, param);
        }
      });
    },
    // 给目录绑定资源
    addResourse(catalog, data) {
      let resourse = {
        catalogId: catalog.id,
        courseId: data.courseId,
        list: [
          {
            catalogId: catalog.id,
            courseId: data.courseId,
            resourceId: data.resourceId,
            type: data.type,
          },
        ],
      };
      api
        .postAddMaterialOne(resourse)
        .then((res) => {
          if (res.code == "0") {
            this.$emit("handleTreeNodeClick", catalog);
            this.$message.success("保存成功");
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enterBlur(event, data) {
      event.target.blur(data);
    },
    //删除节点
    remove(node, data, resourse) {
      if (data.children && data.children.length !== 0) {
        this.$message.warning("此节点有子节点不可删除");
      } else {
        this.$confirm("是否删除该节点?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (data.resourceBase.length > 0) {
              // 如果目录下有资源，则先删除资源，再删除目录
              if (resourse) {
                this.removeResourse(data, resourse);
              } else {
                this.removeResourse(data, data.resourceBase[0]);
              }
            } else {
              // 目录下没有资源，删除目录
              this.removeCatalog(data);
            }
          })
          .catch(() => {});
      }
    },
    // 删除目录下的素材
    removeResourse(data, resourse) {
      let daleteResourse = {
        catalogId: data.id,
        courseId: this.courseId,
        list: [resourse.id],
      };
      api
        .batchDeleteSource(daleteResourse)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("删除素材成功");
            this.removeCatalog(data);
          } else if (res.code == "1") {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("系统错误");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 删除目录
    removeCatalog(data) {
      api
        .deleteCatalog(data.id)
        .then((res) => {
          if (res.code == "0") {
            this.defaultExpansion=data.catalogParentId;
            this.getCourseCatalog();
            this.$emit("setStatus", 3);
            this.$message.success("删除目录成功");
          } else if (res.code == "1") {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("系统错误");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 手动刷新tree数据。空id的都清除掉
    resertTree(arr) {
      [].forEach.call(arr, (item, index) => {
        if (!item.id) arr.splice(index, 1);
        if (item.children && item.children.length) {
          this.resertTree(item.children);
        }
      });
    },
    // 鼠标移入移出事件
    treeMouseOver(e, data) {
      if (data.isResoures) return;
      this.iconIsShow = data.id;
    },
    treemouseLeave() {
      if (!this.popover_visible) {
        this.iconIsShow = -1;
      }
      this.popover_visible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.app_tree {
  min-width: 200px;
  margin: 0 15px;
  /deep/ .el-tree {
    background: #f6f6f6;
  }
  /deep/ .el-tree-node__content {
    height: 40px;
    margin-bottom: 10px;
    border-radius: 5px;
    background: #2b2a33;
    .custom-tree-node {
      padding-right: 8px;
      width: 100%;
      color: #ffffff;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      /*font-size: 15px;*/
      position: relative;
    }
    .catalogedtordel {
      display: inline-block;
      margin-right: 4px;
    }
    .el-icon-circle-plus-outline {
      margin: 0 3px;
      display: none;
      line-height: 40px;
      font-size: 15px;
    }
    .selectType {
      width: 120px;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 5000;
    }
  }
  /deep/ .el-tree-node__children .el-tree-node__content {
    background: #f6f6f6;
    margin-bottom: 4px;
    .custom-tree-node {
      color: #2b2a33;
    }
    &:hover {
      background: #ededed;
    }
  }
  /deep/ .el-tree-node__children {
    .el-tree-node__content {
      margin-left: 10px;
      padding-left: 0px !important;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        margin-left: 20px;
        padding-left: 0px !important;
      }
      .el-tree-node__children {
        .el-tree-node__content {
          margin-left: 30px;
          padding-left: 0px !important;
        }
      }
    }
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background: #2b2a33;
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node__children
    .el-tree-node.is-current
    > .el-tree-node__content {
    background: #007ced;

    .custom-tree-node {
      color: #ffffff;
    }
  }
  .tree-node-block {
    display: inline-block !important;
  }
}
.zl_sidebar_popper .popper_p,
.zl_sidebar_popper1 .popper_p {
  display: flex;
  /*justify-content: space-around;*/
  margin: 5px 0;
  padding: 5px 0;
  border-radius: 4px;
  cursor: pointer;
  &:hover{
    background: #e6e6e6;
  }
  img{
    width: 20px;
    margin: 0 6px;
  }

}
</style>
<style>
.zl_sidebar_popper1 {
  width: 100px;
  min-width: 100px;
}
.zl_sidebar_popper {
  width: 100px;
  min-width: 100px;
  margin-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/component/zl-sidebar.vue